import {
  ErrorMessageEs,
  ErrorMessageEn,
  SuccessMessageEn,
  SuccessMessageEs,
} from '../../../../constants/alerts';
import { Candidate } from '../../../../types/candidates';
import { successHandler, errorHandler } from '../../../utils';
import {
  CandidateBuilder,
  UpdateCandidateCompletedInput,
  UpdateCandidateScoreOutput,
} from '../candidates.types';

export const updateCandidateCompleted = (builder: CandidateBuilder) =>
  builder.mutation<UpdateCandidateScoreOutput, UpdateCandidateCompletedInput>({
    query: () => ({
      url: '/candidates/update-completed',
      method: 'PATCH',
    }),
    transformResponse: (queryResponse: { data: Candidate }, _, arg) => {
      successHandler(
        (arg.lang ?? 'en') === 'en'
          ? SuccessMessageEn.UpdateCandidate
          : SuccessMessageEs.UpdateCandidate,
        true
      );
      return queryResponse.data;
    },
    transformErrorResponse: (error, _, arg) => {
      errorHandler(
        '[updateCandidateCompletedEndpoint]',
        (arg.lang ?? 'en') === 'es'
          ? ErrorMessageEs.UpdateCandidateFail
          : ErrorMessageEn.UpdateCandidateFail,
        error,
        true
      );
      return error.data;
    },
    invalidatesTags: (result, error, arg) => [
      { type: 'Candidate', Id: arg.candidateId },
    ],
  });
